var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ga"},[_c('div',{staticClass:"sidebar"},[_c('ul',_vm._l((_vm.tocList),function(t){return _c('li',{key:t.id},[_c('router-link',{attrs:{"to":("/ga/" + (t.id))}},[_vm._v("\n           "+_vm._s(t.text)+"\n         ")])],1)}))]),_c('div',{staticClass:"main"},[_c('GaContent')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523077c1","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ga.vue
// module id = null
// module chunks = 